import React, { useRef } from 'react'
import {
  ScrollAreaCorner,
  ScrollAreaRoot,
  ScrollAreaThumb,
  ScrollAreaViewport,
  ScrollAreaViewportProps,
  ScrollBar,
  cn,
} from 'ui'
import { PDF_SCROLLABLE_CONTAINER_ID } from './Viewer'

export const ScrollableContainer = React.forwardRef<
  React.ComponentRef<typeof ScrollAreaViewport>,
  ScrollAreaViewportProps & {
    headerHeight: `${number}rem`
    withScrollbar?: boolean,
    stickyChildren?: React.ReactNode
  }
>(
  (
    { children, withScrollbar = true, headerHeight, stickyChildren, className, ...props },
    ref
  ) => {
    return (
      <ScrollAreaRoot
        style={{
          height: `calc(100vh - ${headerHeight})`,
        }}
        className={cn(
          'relative overflow-hidden flex w-[calc(100%-36rem)] flex-col bg-gray-100'
        )}
        type='always'
      >
        {stickyChildren}
        <ScrollAreaViewport
          {...props}
          className={cn('relative', className)}
          ref={ref}
          id={PDF_SCROLLABLE_CONTAINER_ID}
        >
          {children}
        </ScrollAreaViewport>
        {withScrollbar && (
          <ScrollBar orientation='vertical'>
            <ScrollAreaThumb />
          </ScrollBar>
        )}

        {withScrollbar && (
          <ScrollBar orientation='horizontal'>
            <ScrollAreaThumb />
          </ScrollBar>
        )}

        <ScrollAreaCorner />
      </ScrollAreaRoot>
    )
  }
)
